<div class="banner-info-container">
  <div class="banner-info-title">
    {{ title }}
  </div>
  <div class="banner-info-line-container">
    <div class="banner-info-line">
    </div>
  </div>
  <div class="banner-info-list">
    @for (item of items; track item) {
      <div class="banner-info-item">
        {{ item }}
      </div>
    }
  </div>
</div>
